window.MainNavigation = (function () {

    var selectors = {
        pageContent: '#page-content',
        navItems: '.main-navigation__link',
        submenuContainer: '#main-navigation__submenu-container',
        submenuItemsContainer: '#main-navigation__submenu-links',
        container: '#main-navigation',
        linksContainer: '#main-navigation__links-container',
        headerButtonsContainer: '#main-navigation__buttons-container',
        accountBalance: '.account-widget__balance-sum[js-node="view-balance__sum"]',
        accountProfileBalance: '.profile__balance-sum[js-node="view-balance__sum"]',
        profileBonusBalance: '.profile__bonus-sum[js-node="view-balance__sum"]',
        bonusBalance: '[js-node="view-bonus__sum"]',
        logout: '[js-node="logout"]'
    };

    /* на 09.06.2025 notification все еще используется для обновления баланса на юникоме */
    var notification = {
        //v2.0
        updateAccountBalance: function (val) {
            accountBalance = val;
            var accountBalanceEl = $(selectors.accountBalance);
            var accountProfileBalanceEl = $(selectors.accountProfileBalance);
            accountBalanceEl.attr('data-sum', val);
            accountProfileBalanceEl.attr('data-sum', val);
            if (!isNaN(parseFloat(accountBalanceEl.html()))) {
                accountBalanceEl.html(app.numberToString(val.toFixed(2)).replace('.', ','));
                accountProfileBalanceEl.html(app.numberToString(val.toFixed(2)).replace('.', ','));
            }
        },
        //v2.0
        updateAccountBonusPoints: function (val) {
            globalAppSettings.currentUser.bonuses = parseInt(val);
            var bonusBalanceEl = $(selectors.bonusBalance);
            var profileBonusBalanceEl = $(selectors.profileBonusBalance);
            bonusBalanceEl.attr('data-sum', val);
            profileBonusBalanceEl.attr('data-sum', val);
            if (!isNaN(parseFloat(bonusBalanceEl.html()))) {
                bonusBalanceEl.html(app.numberToString(val));
                profileBonusBalanceEl.html(app.numberToString(val));
            }
        }
    };

    return {
        init: function () {
            if (globalAppSettings.isMobileDevice && !globalAppSettings.isMobileDeviceInDesktopMode) {
                return;
            }

            this.items = $(selectors.navItems);
            this.bindUI();
            this.updateSubmenu();
        },
        bindUI: function () {
            var self = this;
            const logout = document.querySelector(selectors.logout);

            if(logout) {
                logout.addEventListener('click', (e)=> {
                    const broadcastList = document.getElementById('broadcast-list');
                    if(broadcastList.children.length) {
                        e.preventDefault()
                        const logoutEvent = new CustomEvent('logout', {
                            bubbles: true,
                            detail: {
                                href: e.currentTarget.href,
                            }
                        });
                        document.dispatchEvent(logoutEvent);
                    }
                 })
            }


            self.items.on('click', function () {
                if ($(this).data('nopage') === undefined) {
                    self.setActive($(this));
                }
                setTimeout(function () {
                    $(selectors.submenu).removeAttr('style');
                }, 500);
            });

            $(document).on('mouseenter', '#account-widget__navigation-block', function () {
                if (accountMenuHideTimeout) {
                    clearTimeout(accountMenuHideTimeout);
                }

                $(this).addClass('m-expanded');
            });

            var accountMenuHideTimeout;
            $(document).on('mouseleave', '#account-widget__navigation-block', function () {
                var elem = $(this);
                accountMenuHideTimeout = setTimeout(function () {
                    elem.removeClass('m-expanded');
                }, 500);

            });

            /**
             * @param {CustomEvent<{balanceVal: number, bonusPoints: number}>} event - CustomEvent.
             */
            function notificationBalanceUpdateHandler (event) {
                const isDetails = 'detail' in event;

                const balance = isDetails && event.detail.balanceVal ? event.detail.balanceVal : 0;
                const bonuses = isDetails && event.detail.bonusPoints ? event.detail.bonusPoints : 0;

                notification.updateAccountBalance(balance);
                notification.updateAccountBonusPoints(bonuses);
            }
            window.addEventListener('notificationBalanceUpdate', notificationBalanceUpdateHandler);

            const resizeObserver = new ResizeObserver(entries => {
                this.updateSubmenu();
            }).observe($(selectors.container)[0]);
        },
        updatePage: function () {
            if (globalAppSettings.isMobileDevice && !globalAppSettings.isMobileDeviceInDesktopMode) {
                return;
            }

            var self = this;

            var elem = self.items.filter('[data-page=' + $(selectors.pageContent).data('page') + ']');
            if (elem.length > 0) {
                self.setActive(elem);
            }
        },
        setActive: function (elem) {
            this.items.removeClass('m-active');
            elem.addClass('m-active');
        },
        updateSubmenu: function () {
            var self = this;
            $(selectors.linksContainer).hide();
            var containerWidth = $(selectors.container).outerWidth(true) - $(selectors.headerButtonsContainer).outerWidth(true);

            if ($(selectors.submenuContainer).hasClass('is-visible') === false) {
                containerWidth = containerWidth - $('.main-navigation__submenu-title').outerWidth(true);
            }

            $(selectors.linksContainer).show();

            $(selectors.submenuItemsContainer).html('');
            self.items.removeClass('m-invisible');

            var summaryVisibleWidth = 0;
            var hasInvisible = false;
            for (var i = 0; i < self.items.length; i++) {
                summaryVisibleWidth += self.items.eq(i).outerWidth() + parseInt(self.items.eq(i).css('margin-right'));

                if (summaryVisibleWidth - 1 >= containerWidth) {
                    $(selectors.submenuItemsContainer).append(self.items.eq(i).clone().removeClass('main-navigation__link').addClass('dropdown__item'));
                    self.items.eq(i).addClass('m-invisible');
                    hasInvisible = true;
                }
            }

            if (hasInvisible) {
                $(selectors.submenuContainer).addClass('is-visible');
            } else {
                $(selectors.submenuContainer).removeClass('is-visible');
            }
        },
        notification: notification
    }
}());